"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DELETE_UPLOADED_DOCUMENT = exports.REMOVE_EXEMPTION_DOCUMENT = exports.REMOVE_DOCUMENT_CIMA = exports.GET_UPLOADED_DOCUMENT = exports.GET_REQUIRED_DOCUMENT = exports.UPLOAD_DOCUMENT_CIMA = exports.UPLOAD_DOCUMENT = exports.GET_DOCUMENT_EXAM_EXEMPTION = exports.GET_DOCUMENT_FILES = exports.GET_DOCUMENT_CIMA = exports.GET_DOCUMENT = void 0;
exports.GET_DOCUMENT = `
	query getDocument($fileName: String) {
		getDocument(fileName: $fileName)    
	}
`;
exports.GET_DOCUMENT_CIMA = `
	query getDocumentCima($fileName: String) {
		getDocumentCima(fileName: $fileName)    
	}
`;
exports.GET_DOCUMENT_FILES = `
	query getDocumentFiles($fileName: String) {
		getDocumentFiles(fileName: $fileName) 
	}
`;
exports.GET_DOCUMENT_EXAM_EXEMPTION = `
	query getDownloadExamExemption($fileName: String) {
		getDownloadExamExemption(fileName: $fileName) 
	}
`;
exports.UPLOAD_DOCUMENT = `
	mutation uploadDocument($fileName: String, $entityName: String, $file: Upload, $applicationPartId: String, $fileSize: String, $personAccountId: String, $type: String, $personExemptionLevelKey: String){
		uploadDocument(fileName: $fileName, entityName: $entityName, file: $file, applicationPartId: $applicationPartId, fileSize: $fileSize, personAccountId: $personAccountId, type: $type, personExemptionLevelKey: $personExemptionLevelKey)
	}
`;
exports.UPLOAD_DOCUMENT_CIMA = `
	mutation uploadDocumentCima($fileName: String, $entityName: String, $subject: String, $description: String, $assessmentType: String, $file: Upload, $type: String, $sku: String){
		uploadDocumentCima(fileName: $fileName, entityName: $entityName, subject: $subject, description: $description, assessmentType: $assessmentType, file: $file, type: $type, sku: $sku)
	}
`;
exports.GET_REQUIRED_DOCUMENT = `
	query getRequiredDocument ($accountId: String, $exemptionReferenceId: String) {
		getRequiredDocument(accountId: $accountId, exemptionReferenceId: $exemptionReferenceId)
	}
`;
exports.GET_UPLOADED_DOCUMENT = `
	query getUploadedDocs ($accountId: String) {
		getUploadedDocs(accountId: $accountId)
	}
`;
exports.REMOVE_DOCUMENT_CIMA = `
	mutation removeDocument($fileName: String) {
		removeDocument(fileName: $fileName)
	}
`;
exports.REMOVE_EXEMPTION_DOCUMENT = `
	mutation removeExemptionDocument($fileName: String) {
		removeExemptionDocument(fileName: $fileName)
	}
`;
exports.DELETE_UPLOADED_DOCUMENT = `
	mutation deleteUploadedDoc ($id: String) {
		deleteUploadedDoc(id: $id)
	}
`;
//# sourceMappingURL=document-upload-queries.js.map